import { render } from "./CharacterCard.vue?vue&type=template&id=69e52ae8"
import script from "./CharacterCard.vue?vue&type=script&lang=js"
export * from "./CharacterCard.vue?vue&type=script&lang=js"

import "./CharacterCard.vue?vue&type=style&index=0&id=69e52ae8&lang=scss"

import exportComponent from "/Users/vklosovych/Desktop/vue-exam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__